window.cohesion('ready', () => {
    const recommendationCards = document.querySelector('[data-recommendation-cards]');
  
    if (!recommendationCards) return;
  
    const isElementInViewport = (el) => {
      const rect = el.getBoundingClientRect();
      return (
        rect.bottom > 0
        && rect.right > 0
        && rect.left < (window.innerWidth || document.documentElement.clientWidth)
        && rect.top < (window.innerHeight - 200 || document.documentElement.clientHeight - 200)
      );
    };
    let cardsViewed = false;
  
    // for when cards appear on page load
    if (isElementInViewport(recommendationCards) && !cardsViewed) {
      window.tagular('beam', 'ElementViewed', {
        '@type': 'redventures.usertracking.v3.ElementViewed',
        webElement: {
          location: 'Recommendation Aritcles',
          position: 'BOTTOM OF PAGE',
          elementType: 'CARDS',
          htmlId: 'recommendation-articles-cards',
        },
      });
      cardsViewed = true;
    }
  
    // for when cards appear after scrolling
    if (!cardsViewed) {
      document.addEventListener('scroll', () => {
        if (isElementInViewport(recommendationCards) && !cardsViewed) {
          window.tagular('beam', 'ElementViewed', {
            '@type': 'redventures.usertracking.v3.ElementViewed',
            webElement: {
              location: 'Recommendation Aritcles',
              position: 'BOTTOM OF PAGE',
              elementType: 'CARDS',
              htmlId: 'recommendation-articles-cards',
            },
          });
          cardsViewed = true;
        }
      });
    }
  
    // tracking on a card clicked
    recommendationCards.addEventListener('click', (e) => {
      window.tagular('beam', 'ElementClicked', {
        '@type': 'redventures.usertracking.v3.ElementClicked',
        webElement: {
          location: 'Recommendation Articles',
          position: 'BOTTOM OF PAGE',
          elementType: 'BUTTON ANCHOR LINK',
          text: e.target.title,
        },
        actionOutcome: 'INTERNALLINK',
      });
    });
  });